import { EditOutlined, EnvironmentOutlined } from '@ant-design/icons'
import KItem from 'app/components/Modules/General/KItem'
import Button from 'app/components/UI-Elements/General/Button'
import { RecordType } from 'app/constants/GlobalTypes'
import { normalizeAddressSummary } from 'app/lib/apollo/normalizers/Rental'
import { ToolBox } from 'app/lib/hooks/toolBox'

import { MemberProps } from '../convention'

type Props = {
  onEditClick: () => void
}

const DeliveryAddressListItem: React.FC<MemberProps<IAddress, Props>> = ({
  props: { onEditClick } = {},
  member: deliveryAddress
}) => {
  const { buttonId } = ToolBox.useId()
  const id = buttonId({ recordType: RecordType.delivery_address, action: 'update' })
  return (
    <KItem
      verticalAlign={true}
      extra={
        <Button data-testid={id} onClick={onEditClick} type="secondary" icon={<EditOutlined />} />
      }
      avatar={<EnvironmentOutlined className="font-size-22" />}
      title={
        <If condition={deliveryAddress}>
          <span className="font-weight-normal font-family-base text-black">
            {normalizeAddressSummary(deliveryAddress)}
          </span>
        </If>
      }
    />
  )
}
export default DeliveryAddressListItem
